import React from 'react';
import NotFoundImage from '../Res/Na_Nov_26-removebg-preview.png';

const NotFound = (props:{width? : number}) => {
    return (
        <div>
            <center><img src={NotFoundImage} alt="Ressource Not Found" width={props.width} draggable="false"/></center>
        </div>
    );
};

export default NotFound;